<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <SelectBanco
                    :model="itemActivo.Id_Banco"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item => (itemActivo.Id_Banco = item.Id_Banco)
                    "
                  />
                </v-flex>
                <v-flex xs6 md2 offset-md2>
                  <v-text-field
                    label="Nº*"
                    v-model="itemActivo.Numero"
                    v-mask="'########'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md2>
                  <Importe
                    label="Importe"
                    :model="itemActivo.Importe"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item => (itemActivo.Importe = item.Importe)
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Remitente*"
                    v-model="itemActivo.Remitente"
                    hint="¿Quién lo entrega?"
                    persistent-hint
                    :rules="[rules.requerido, rules.maximo50]"
                    :readonly="controlSoloLectura"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 md2 offset-md2>
                  <Fecha
                    label="Ingreso"
                    :fecha="itemActivo.FechaIngreso"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item => (itemActivo.FechaIngreso = item.Fecha)
                    "
                  />
                </v-flex>
                <v-flex xs6 md2>
                  <Fecha
                    label="Pago"
                    :fecha="itemActivo.FechaPago"
                    :readonly="controlSoloLectura"
                    :sinFechaMaxima="true"
                    @seleccionarItem="
                      item => (itemActivo.FechaPago = item.Fecha)
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Titular*"
                    v-model="itemActivo.Titular"
                    hint="¿De quién es el cheque?"
                    persistent-hint
                    :rules="[rules.requerido, rules.maximo50]"
                    :readonly="controlSoloLectura"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Plaza"
                    v-model="itemActivo.Plaza"
                    hint="Domicilio de Pago"
                    persistent-hint
                    :rules="[rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-textarea
                    label="Nota"
                    v-model="itemActivo.Nota"
                    :rules="[rules.maximo500]"
                    persistent-hint
                    :readonly="controlSoloLectura"
                    auto-grow
                    rows="2"
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Destinatario"
                    v-model="itemActivo.Destinatario"
                    persistent-hint
                    :rules="[rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md2 offset-md4>
                  <Fecha
                    label="Egreso"
                    :fecha="itemActivo.FechaEgreso"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item => (itemActivo.FechaEgreso = item.Fecha)
                    "
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import Fecha from "@/components/Fecha";
import Importe from "@/components/Importe";
import SelectBanco from "@/components/Banco/SelectBanco";
export default {
  name: "ChequeTerceroCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    Fecha,
    Importe,
    SelectBanco
  },
  data() {
    return {
      titulo: "Cheques de Tercero",
      rutaApi: "ChequeTercero/",
      itemVacio: {
        Id_ChequeTercero: 0,
        Numero: "",
        FechaIngreso: "",
        FechaPago: "",
        Remitente: "",
        Titular: "",
        Id_Banco: 0,
        Plaza: "",
        Nota: "",
        Importe: 0,
        FechaEgreso: "",
        Destinatario: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo15: v => (v || "").length <= 15 || "Máximo 15 caracteres",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres",
        maximo500: v => (v || "").length <= 500 || "Máximo 500 caracteres"
      },
      grillaColumnas: [
        { text: "Banco", value: "NombreBanco" },
        { text: "Nº", value: "Numero" },
        { text: "Remitente", value: "Remitente" },
        { text: "Titular", value: "Titular" },
        { text: "Importe", value: "Importe", mask: "esMoneda" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectBanco");
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectBanco");
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_ChequeTercero)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_ChequeTercero
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
